<div class="slide rounded-t-2xl ">
    <div *ngIf="sectionContent.isDownloadable && media.type !== 'EMBED' && media.type !== 'VID' && media.storage !== 'ext'" class="btn__group">
        <a (click)="downloadMedia()" class="btn btn_height_small">{{ 'player.download-media' | translate }}</a>
        <a #isDownloadable [href]="url" target="_blank"></a>
    </div>
<div class="">
    <msc-heading-actions>
        <h2 class="heading">
            {{ sectionContent.title }}
        </h2>
    </msc-heading-actions>
    <p #descriptionEl *ngIf="sectionContent.description" class="multiline" [innerHTML]="sectionContent?.description | safe:'html'"></p>

    <!-- Barra con botón de expandir (solo video/embed). Maximizamos el reproductor de
         la propia página con un overlay CSS (reutiliza el iframe que ya funciona), en
         vez de un modal — el modal rompía la URL de Vimeo. El botón interno de YouTube
         es cross-origin y no se puede enganchar, por eso usamos este botón propio. -->
    <div class="video-toolbar" *ngIf="!detectPhone() && !detectIpad() && (media.type === 'EMBED' || media.type === 'VID')">
        <button type="button" class="video-expand-btn" [class.video-expand-btn--max]="isMaximized"
            (click)="toggleMaximize()"
            [attr.title]="(isMaximized ? 'words.close' : 'player.cheatsheet.full-screen') | translate">
            <svg *ngIf="!isMaximized" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-4 h-4">
                <path d="M8 3H5a2 2 0 0 0-2 2v3"></path>
                <path d="M21 8V5a2 2 0 0 0-2-2h-3"></path>
                <path d="M3 16v3a2 2 0 0 0 2 2h3"></path>
                <path d="M16 21h3a2 2 0 0 0 2-2v-3"></path>
            </svg>
            <svg *ngIf="isMaximized" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="w-4 h-4">
                <path d="M4 14h3a2 2 0 0 1 2 2v3"></path>
                <path d="M20 10h-3a2 2 0 0 1-2-2V5"></path>
                <path d="M14 20v-3a2 2 0 0 1 2-2h3"></path>
                <path d="M10 4v3a2 2 0 0 1-2 2H5"></path>
            </svg>
            <span>{{ (isMaximized ? 'words.close' : 'player.cheatsheet.full-screen') | translate }}</span>
        </button>
    </div>

    <div *ngIf="!detectPhone() && !detectIpad()" class="slide_video"
        [class.slide_video--max]="isMaximized" style="text-align: center;">
        <media-holder *ngIf="media" [media]="media" [downloadable]="!!sectionContent.isDownloadable" [reloadUrl]="reloadUrl"></media-holder>
    </div>

    <div class="" *ngIf="ipad.enableDownload" style="text-align: center;">
        {{ 'player.download-pdf' | translate }}
    </div>

    <div *ngIf="detectPhone() || ipad.enableDownload" style="text-align: center;">
        <a (click)="downloadMedia()" class="btn btn_color_grey btn_height_small">
            {{ media.title }}
        </a>

        <a #isDownloadable [href]="url" target="_blank"></a>
    </div>

    <div id="m-loading" class="m-loading" *ngIf="detectIpad() && ipad.ready && !ipad.iframeLoaded">
        {{ 'player.loading' | translate }}
    </div>

    <div id="iframe-wrapper" class="m-ipad" *ngIf="detectIpad() && ipad.ready"></div>

    <!-- Etiqueta del tipo de contenido, debajo del embed -->
    <span class="block text-sm font-normal text-gray-600 my-2 px-4 py-3 bg-gray-50 border-t border-gray-200">{{ 'player.lesson-media.name' | translate }}</span>

    <msc-next-prev-btn (isFinished)="activityFinished()" [validate]="true" [doneAt]="sectionContentSession.doneAt" [loading]="loading"></msc-next-prev-btn>
</div></div>

<ng-template #modalFullScreen let-modal>
    <div class="modal-header">
        <span></span>
        <button type="button" class="close" aria-label="Close" (click)="closeModal(modalFullScreen)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div style="height: 100%;">
            <iframe [src]="urlIframe" width="100%" height="100%" allowfullscreen></iframe>
        </div>
    </div>
</ng-template>

<app-footer [context]="'media'" [contextId]="media?.id"></app-footer>

<app-timer [timerService]="timerService" (close)="timerInit()"></app-timer>

<style>
    .m-loading {
        text-align: center;
    }

    .m-ipad {
        width: 100%;
    }

    .video-toolbar {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0.5rem;
    }

    .video-expand-btn {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.4rem 0.75rem;
        border: 1px solid #E8EAEF;
        border-radius: 9999px;
        background: #fff;
        color: #22304C;
        font-size: 0.8rem;
        font-weight: 600;
        cursor: pointer;
        transition: background .2s ease, border-color .2s ease;
    }

    .video-expand-btn:hover {
        background: #F6F7F9;
        border-color: #d7dbe3;
    }

    /* Estado maximizado: el reproductor se vuelve overlay a pantalla completa.
       Reutiliza el iframe ya cargado (funciona con Vimeo y YouTube). */
    .slide_video--max {
        position: fixed;
        inset: 0;
        z-index: 100000;
        width: 100vw;
        height: 100vh;
        margin: 0 !important;
        background: white;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        overflow: auto;
    }

    /* En maximizado el reproductor ocupa todo el ancho y conserva 16:9, anclado
       arriba (sin franjas negras enormes arriba/abajo). */
    .slide_video--max media-holder,
    .slide_video--max .media-holder,
    .slide_video--max media-video,
    .slide_video--max media-embed {
        display: block;
        width: 100vw;
        max-width: 100vw;
    }

    .slide_video--max .media-video-embed,
    .slide_video--max .embed {
        width: 100vw;
        padding-bottom: 56.25% !important;
        height: 0 !important;
        border-radius: 0;
    }

    /* Botón flotante para contraer mientras está maximizado. */
    .video-expand-btn--max {
        position: fixed;
        top: 16px;
        right: 16px;
        z-index: 100001;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
        border-color: transparent;
    }

    .video-expand-btn--max:hover {
        background: rgba(0, 0, 0, 0.8);
    }

 /*   @media only screen and (min-width: 320px) {
        .slide {
            margin: 1rem 0 0.5rem;
            width: 100%;
        }
    }*/
/*
    @media only screen and (min-width: 768px) {
        .slide {
            margin: 8rem 0 1.5rem;
            width: 100%;
        }
    }*/
</style>
